import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";
const ZFormPendingFundTransactionStructure = observer((props) => {

	const { className, title, count, filter = "", redirectLink } = props;

	const history = useHistory();

	const handleRedirect = () => {
		if (filter) {
			localStorage.setItem("refund_status", JSON.stringify(filter));
		}
		history.push({
			pathname: redirectLink,
		});
	}

	return (
		<>
			<li className={`widget_row ${className}`} onClick={handleRedirect}>
				<div className="widget_left">
					<div className="fund_icon"></div>
					<p>{title}</p>
				</div>
				<div className="widget_right">
					<p>{count}</p>
				</div>
			</li>
		</>

	)
})

export default ZFormPendingFundTransactionStructure

